module.exports = __webpack_public_path__ + "static/img/y2.2b063608.png";